module.exports = __webpack_public_path__ + "img/sdg_en_(15).d395889a.png";